import * as apiGetPermissions from "@/api/idam/getPermissions";
import { _ } from "core-js";

export default {
    namespaced: false,
    state: () => ({
        hasFetchedPermissions: false,
        permissions: null,
    }),
    mutations: {
        GOT_PERMISSIONS(state, permissions) {
            state.permissions = permissions
            state.hasFetchedPermissions = true;
        },
    },
    actions: {
        async getPermissions({ commit }) {
            const result = await apiGetPermissions.get();
            if (result) {
                commit("GOT_PERMISSIONS", result);
                console.log("[IDAM] Permissions received", result);
            }
        },
    },
    getters: {
        hasFetchedPermissions: state => state.hasFetchedPermissions,
        hasPermission: state => (permId) => {
            if (!state.permissions) return false;
            return state.permissions.globalPermissions.includes(permId);
        },
        // hasPermissionForActiveVenue: (state, getters) => (permId) => {
        //     let activeVenue = localStorage.getItem("activeVenue");
        //     // If the active venue is not currently set, but we do have permissions, then assume the first venue is selected (because the router does the same)
        //     if (activeVenue == null && state.permissions && state.permissions.venuePermissions.length > 0) activeVenue = state.permissions.venuePermissions[0].venueId;
        //     return getters.hasPermissionForEntity(permId, activeVenue)
        // },
        hasPermissionForEntity: state => (permId, forEntityId) => {
            if (!state.permissions) return false;
            return state.permissions.globalPermissions.includes(permId) || _.some(state.permissions.venuePermissions, v => v.venueId === forEntityId && v.permissions.includes(permId))
        },
    }
};
